import React from "react";
import FontIcon from "react-md/lib/FontIcons";

import AtollonThumb from "../../../assets/img/atollon-thumb.png";

const Profile = () => {
  return (
    <div className="profile-photo">
      <img src={AtollonThumb} alt="User" className="photo" />
      <FontIcon className="edit">edit</FontIcon>
    </div>
  );
};

export default Profile;



// WEBPACK FOOTER //
// ./src/components/settings/profile/Photo.js